import { API, EntityType } from "core/api";
import { FETCH_ENTITY_QUERY_KEY } from "../screens";

export const fetchUserQueryKey = [
  FETCH_ENTITY_QUERY_KEY,
  EntityType.SYS_USER,
  [],
  API.myAccount.myaccount,
];
